import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

import Loader from '../../../components/Loader';
import ManageRefund from '../../../components/siteadmin/ManageRefund/MangeRefund';

import getAllRefundReservation from './getAllRefundReservation.graphql';

class RefundManagement extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getAllRefundReservation: PropTypes.array,
        })
    }

    render() {
        const { title, getAllRefunds } = this.props;
        return <ManageRefund title={title} getAllRefunds={getAllRefunds} />

    }
}

export default compose(
    graphql(getAllRefundReservation, {
        name: 'getAllRefunds',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only'
        }
    })
)(RefundManagement);